import { Flex, StyleSystemProps, styled, css } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledQuickAccessContainer = styled(Flex)``;
const quickAccessContainerStyles: StyleSystemProps = {
  flexDirection: 'row',
  justifyContent: { _: 'flex-start', md3: 'center' },
  columnGap: 1,
  backgroundColor: 'white',
};

export const StyledQuickAccessItem = styled(Flex)``;
const quickAccessItemStyles = (isSelected: boolean, isDisabled: boolean): StyleSystemProps => ({
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: pxToRem(36),
  height: pxToRem(44),
  paddingX: 3,
  border: '2px solid',
  borderColor: 'transparent',
  borderRadius: 8,
  cursor: 'pointer',
  ...(isSelected && {
    borderColor: 'mono14',
    backgroundColor: 'mono2',
  }),
  color: isDisabled ? 'mono8' : 'mono14',
  pointerEvents: isDisabled ? 'none' : 'auto',
});

export const customScrollbarCss = css`
  /* width */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 8px;
  }
`;

export const styles = {
  quickAccessContainer: quickAccessContainerStyles,
  quickAccessItem: quickAccessItemStyles,
};
